module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Schroeder_Genesis_text_CC2#toc2"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTOCAnchor-3"
    }
  }), _vm._v("Abbreviations")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("CCCM\tCorpus Christianorum, Continuatio Mediaevalis. Turnhout: Brepols, 1966-­.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("CCSL\tCorpus Christianorum, Series Latina. Turnhout: Brepols, 1953-­.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("CSEL\tCorpus Scriptorum Ecclesiasticorum Latinorum. 85 vols. Vienna, 1866. New York: Johnson Reprint, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("FC\tFathers of the Church. Washington, D.C.: Catholic University of America Press, 1947-­.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("LCL\tLoeb Classical Library. Cambridge, Mass.: Harvard University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NRSV\tNew Revised Standard Version Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("PL\tPatrologia Latina. 221 vols. Ed. J.-­P Migne. Paris, 1844-55.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SC\tSources Chrétiennes. Paris: Éditions du Cerf, 1941-­.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SH")]), _vm._v("\tPeter Comestor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scholastica Historia")]), _vm._v(" [= "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scholastic History")]), _vm._v("].")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v("\tThomas Aquinas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summa Theologiae.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf5cd1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schroeder_Genesis_text_CC-4.vue
// module id = 66
// module chunks = 0